/* ee-cine.js — Eyewear Essentials
   1) Word-by-word headline reveal on the hero h1 and the Shop-the-look h2.
   2) Pinned story section (sections/ee-story-pin.liquid).
   Hiding classes (.eec-split, .eesp-ready) are only ever added here. */
(function () {
  'use strict';

  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var RM = mq('(prefers-reduced-motion: reduce)').matches;
  var HAS_IO = 'IntersectionObserver' in window;

  /* ------------------------------------------------------------ split text */
  var SPLIT = ['.eeh-hero-copy h1', '.eesl-head h2'];
  var STAGGER = 40;

  function plainText(el) {
    var c = el.cloneNode(true);
    Array.prototype.forEach.call(c.querySelectorAll('br'), function (br) { br.replaceWith(' '); });
    return (c.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function wrapWords(node, state) {
    Array.prototype.slice.call(node.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var text = n.nodeValue;
        if (!text.trim()) return;
        var frag = document.createDocumentFragment();
        text.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var w = document.createElement('span');
          w.className = 'eec-w';
          w.setAttribute('aria-hidden', 'true');
          var i = document.createElement('span');
          i.className = 'eec-i';
          i.textContent = p;
          i.style.setProperty('--eec-d', (state.count++ * STAGGER) + 'ms');
          w.appendChild(i);
          frag.appendChild(w);
        });
        n.replaceWith(frag);
      } else if (n.nodeType === 1 && n.tagName !== 'BR') {
        wrapWords(n, state);            /* keeps <em> (and its italic) intact */
      }
    });
  }

  /* The hero copy and the Shop-the-look head fade in on their own (opacity
     transition owned by their sections). Start the word reveal after that
     fade, or the words would animate inside an invisible parent. */
  function afterParentReveal(el, cb) {
    var p = el.parentElement, hops = 0;
    while (p && hops++ < 4) {
      var cs = getComputedStyle(p);
      if (parseFloat(cs.opacity) < 1 && cs.transitionDuration !== '0s') {
        var done = false;
        var fin = function () { if (!done) { done = true; cb(); } };
        p.addEventListener('transitionend', function h(e) {
          if (e.target === p && e.propertyName === 'opacity') { p.removeEventListener('transitionend', h); fin(); }
        });
        setTimeout(fin, 1500);
        return;
      }
      p = p.parentElement;
    }
    cb();
  }

  function splitText(root) {
    if (RM) return;
    var targets = [];
    SPLIT.forEach(function (sel) {
      (root || document).querySelectorAll(sel).forEach(function (el) { if (!el.dataset.eecSplit) targets.push(el); });
    });
    if (!targets.length) return;

    targets.forEach(function (el) {
      el.dataset.eecSplit = '1';
      el.setAttribute('aria-label', plainText(el));
      wrapWords(el, { count: 0 });
      el.classList.add('eec-split');            /* the only place the hiding class is added */
    });

    var pending = targets.slice();
    function fire(el) {
      var k = pending.indexOf(el);
      if (k < 0) return;
      pending.splice(k, 1);
      afterParentReveal(el, function () { el.classList.add('eec-in'); });
    }
    if (HAS_IO) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); fire(en.target); } });
      }, { threshold: 0.15 });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(fire);
    }
    /* Failsafe: never leave a headline hidden. */
    setTimeout(function () { pending.slice().forEach(function (el) { el.classList.add('eec-in'); }); pending = []; }, 2500);
  }

  /* --------------------------------------------------------- pinned story */
  function hydrate(img) {
    if (img.dataset.src) { img.src = img.dataset.src; if (img.dataset.srcset) img.srcset = img.dataset.srcset; img.removeAttribute('data-src'); }
    img.hidden = false;
  }

  function storyPin(root) {
    if (root.dataset.eespReady) return;
    root.dataset.eespReady = '1';
    var imgs = Array.prototype.slice.call(root.querySelectorAll('.eesp-img'));
    var steps = Array.prototype.slice.call(root.querySelectorAll('.eesp-step'));
    if (!imgs.length || !steps.length) return;

    /* ≤700px, or no IO: plain stacked block, first image only. */
    if (mq('(max-width: 700px)').matches || !HAS_IO) return;

    root.classList.add('eesp-ready');
    function setActive(i) {
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
    }
    var hydrated = false;
    var near = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting || hydrated) return;
      hydrated = true;
      imgs.forEach(hydrate);
      near.disconnect();
    }, { rootMargin: '600px 0px' });
    near.observe(root);

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) setActive(steps.indexOf(en.target)); });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    steps.forEach(function (s) { spy.observe(s); });
    setActive(0);
  }

  function init(root) {
    var scope = root || document;
    try { splitText(scope); } catch (e) {}
    try { scope.querySelectorAll('[data-ee-story-pin]').forEach(storyPin); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
